<div [ngClass]="useInline ? 'd-inline ml-16r' : 'd-flex'">
    <img class="flag px-1 py-1" src="assets/images/Icones_Divers_Fr_Flag.svg" />
    <img class="flag px-1 py-1" src="assets/images/Icones_Divers_En_Flag.svg" />
    <img class="flag px-1 py-1" src="assets/images/Icones_Divers_Es_Flag.svg" />
</div>

